module.exports = __webpack_public_path__ + "img/stop.66ebea7f.svg";